





























































































import { Component, Prop, Vue } from "vue-property-decorator";
import { IGuest } from "@/@types/admin/guest/user";
import { IRoom, IRoomControl } from "@/@types/hotel/room";
import { IVirtualRooma } from "@/@types/hotel/virtual_rooms";
import { ICruise } from "@/@types/cruiseOffers/cruiseList";

import RoomRegistrationGests from "@/components/tables/administration/guests/room-registration-guests.vue";
import GuestTable from "@/components/tables/administration/guests/guest-table.vue";
import LightGuestList from "@/components/tables/administration/guests/light-guest-list.vue";
import ChoiceDropVroom from "./choice-drop-vroom.vue";
import WievButton from "@/components/buttons/wiev-button.vue";
import FullGuestCard from "@/components/card/guest/full-guest-card.vue";

@Component({
  components: {
    "rooms-control": RoomRegistrationGests,
    "guest-card": FullGuestCard,
    ChoiceDropVroom,
    LightGuestList,
    GuestTable,
    WievButton,
  },
})
export default class GuestList extends Vue {
  @Prop({ type: Array, default: () => [] }) virtualRooms!: Array<IVirtualRooma>;
  @Prop({ type: Array, default: () => [] }) roomStatuses!: Array<IRoomControl>;
  @Prop({ type: Array, default: () => [] }) roomLevels!: Array<IRoomControl>;
  @Prop({ type: Array, default: () => [] }) roomTypes!: Array<IRoomControl>;
  @Prop({ type: Array, default: () => [] }) guests!: Array<IGuest>;
  @Prop({ type: Array, default: () => [] }) rooms!: Array<IRoom>;
  @Prop({ type: String, default: "all" }) registrated!: string;
  @Prop({ type: Object, default: null }) sort!: { name: string; data: string };
  @Prop({ type: Array, default: () => [] }) cruises!: Array<ICruise>;
  @Prop({ type: Array, default: () => [] }) cruiseCodes!: Array<string>;
  @Prop({ type: Array, default: () => [] }) citizenships!: Array<string>;

  @Prop({ type: Date, default: () => new Date() }) day!: Date;
  @Prop({ type: String, default: "" }) shipCode!: string;
  @Prop({ type: String, default: "" }) wiev!: string;
  @Prop({ type: String, default: "" }) search!: string;

  // shows
  @Prop({ type: Boolean, default: false }) show_comment!: boolean;
  @Prop({ type: Boolean, default: false }) show_gender!: boolean;
  @Prop({ type: Boolean, default: false }) show_email!: boolean;
  @Prop({ type: Boolean, default: false }) show_order_number!: boolean;
  @Prop({ type: Boolean, default: false }) show_ad!: boolean;
  @Prop({ type: Boolean, default: true }) show_room!: boolean;
  @Prop({ type: Boolean, default: true }) show_phone_number!: boolean;
  @Prop({ type: Boolean, default: true }) show_birthday!: boolean;
  @Prop({ type: Boolean, default: true }) show_document!: boolean;
  @Prop({ type: Boolean, default: true }) show_age!: boolean;
  @Prop({ type: Boolean, default: true }) show_check!: boolean;
  @Prop({ type: Boolean, default: true }) show_table!: boolean;
  @Prop({ type: Boolean, default: true }) show_zit!: boolean;
  @Prop({ type: Boolean, default: true }) show_plan_guests!: boolean;
  @Prop({ type: Boolean, default: true }) show_plan_children!: boolean;
  @Prop({ type: Boolean, default: true }) show_plan_pensioners!: boolean;
  @Prop({ type: Boolean, default: false }) show_plan_cell!: boolean;
  @Prop({ type: String, default: "" }) children!: string;
  @Prop({ type: Boolean, default: false }) pensioners!: boolean;
  @Prop({ type: String, default: "" }) birthday!: string;
  @Prop({ type: String, default: "" }) cruise_code!: string;
  @Prop({ type: String, default: "" }) gender!: string;
  @Prop({ type: String, default: "" }) doc_type!: string;
  @Prop({ type: String, default: "" }) citizenship!: string;
  @Prop({ type: String, default: "" }) room_type!: string;
  @Prop({ type: String, default: "" }) room_level!: string;

  width = window.innerWidth;
  showModal = true;
  show = true;

  selected = "";
  guest_id = "";

  get layer(): string {
    if (this.wiev == "checkerboard") return "checkerboard";
    if (this.wiev == "plan") return "rooms-control";
    return "guest-table";
  }

  get guest(): IGuest | null {
    const guest = this.guests.find((el) => el._id == this.guest_id);
    return guest ? guest : null;
  }

  changeGuest(data: Partial<IGuest>, id: string): void {
    this.$emit("check", data, id, false);
  }

  checkInVroom(guest: Partial<IGuest>, id: string): void {
    this.$emit("check", guest, id, true);
  }

  deleteGuestsByCruise(code: string): void {
    const vrooms: Array<string> = [];
    const processedVrooms = new Set<string>();
    this.virtualRooms.forEach((vr) => {
      const hasMatchingGuest = vr.guests.some((guestId) => {
        return this.guests.some(
          (g) => g._id === guestId && g.stay_data?.cruise_code === code
        );
      });
      if (hasMatchingGuest && !processedVrooms.has(vr._id)) {
        processedVrooms.add(vr._id);
        vrooms.push(vr._id);
      }
    });
    this.$bvModal.hide("choice-drop-vroom-modal");
    this.$emit("deleteVRooms", vrooms);
  }

  async deleteguest(guestid: string): Promise<void> {
    try {
      const result = await this.$bvModal.msgBoxConfirm(
        String(this.$i18n.t("main.confirms.ok")),
        {
          title: String(this.$i18n.t("HotelInfo.confirm.delete")),
        }
      );

      if (result === true) {
        this.$emit("deleteguest", guestid);
        this.$bvModal.hide("guests");
      }
    } catch {
      this.$notify({
        group: "global",
        text: String(this.$i18n.t("error.empty400")),
        type: "warn",
      });
    }
  }

  openGuestForm(room: string): void {
    this.$bvModal.hide("guest-card-modal");
    this.$bvModal.hide("guest-changer");
    this.$emit("openGuestChangerModal", "", room);
  }

  async dropVroomsCollection(vrooms: Array<string>): Promise<void> {
    try {
      const result = await this.$bvModal.msgBoxConfirm(
        String(this.$i18n.t("main.confirms.ok")),
        {
          title: String(this.$i18n.t("virtual-rooms.drop")),
        }
      );
      if (result === true) {
        this.$bvModal.hide("choice-drop-vroom-modal");
        this.$emit("deleteVRooms", vrooms);
      }
    } catch {
      this.$notify({
        group: "global",
        text: String(this.$i18n.t("error.empty400")),
        type: "warn",
      });
    }
  }

  widthCalculator(): void {
    this.width = window.innerWidth;
  }

  mounted(): void {
    window.addEventListener("resize", () => this.widthCalculator());
  }

  destroyed(): void {
    window.removeEventListener("resize", () => this.widthCalculator());
  }
}
